import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const RequirementService = {

  getAllRequirement: async () => {
    try {
      const response = await axios.get(ENDPOINT.Requirement);
      return response.data;
    } catch (error) {
      console.error("Error fetching Requirement:", error.message);
      throw error;
    }
  },

  getAllByProject: async (pro_id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Requirement}/project/${pro_id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Requirement:", error.message);
      throw error;
    }
  },

  getDropdownValues: async (field) => {
  try {
    const response = await axios.get(`${ENDPOINT.Requirement}/dropdown/${field}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching dropdown values:", error.message);
    throw error;
  }
},

  getLastRequirement: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Requirement}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Requirement:", error.message);
      throw error;
    }
  },

  getRequirementById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Requirement}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Requirement:", error.message);
      throw error;
    }
  },

  createRequirement: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Requirement, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Requirement:", error.message);
      throw error;
    }
  },

  updateRequirement: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Requirement}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Requirement:", error.message);
      throw error;
    }
  },

  deleteRequirement: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Requirement}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Requirement:", error.message);
      throw error;
    }
  },
};